// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3f5d_{position:relative}._2xhM1{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin:.25rem 0}._1KCRh{width:20px;width:1.25rem;margin-right:.25rem}._1stln{font-size:16px;font-size:1rem;font-weight:300;line-height:26px;line-height:1.625rem;font-family:var(--base-font)}", ""]);
// Exports
exports.locals = {
	"root": "_3f5d_",
	"info": "_2xhM1",
	"icon": "_1KCRh",
	"text": "_1stln"
};
module.exports = exports;
